export { default } from "./GeniusAssignmentContainer";
